import React from 'react';
import './TimeLineTree.scss';
import { Row, Col } from 'antd';

// Lộ trình dự thi
// 6/10/2023: Mở form đăng ký và bài dự thi
// 27/10/2023: Đóng form đăng ký
// 31/11/2023: Công bố TOP 30 lọt vào bán kết
// 12/11/2023: Video shooting - Thi trực tiếp, mỗi thí sinh thể hiện bài diễn đạt chuẩn bị từ trước theo chủ đề được Ban Tổ Chức công bố.
// 20/11/2023: Bắt đầu cuộc bình chọn TOP 10
// 02/12/2023: Kết thúc cuộc bình chọn TOP 10
// 04/12/2023: Công bố các thí sinh vào lọt vào Vòng Chung Kết 
// 10/12/2023: Vòng Chung Kết, vòng thi trực tiếp, thí sinh diễn thuyết với các chủ đề, từ khoá bất ngờ do Ban Tổ Chức cung cấp.
// Thông tin liên hệ:
// Email: skillcetera@gmail.com
// Điện thoại: 0787 727 888 (Mr. Hảo)
// 0832 110 278 (Ms. Trang)
// 0825 497 013 (Liên hệ nhà tài trợ - Ms. Phương) 


const TimeLineTree: React.FC = () => (
    <Row justify={'center'}>
        <Col>
            <div className="timeline" style={{
                fontFamily: 'conthrax',
                textAlign: 'center',
            }}>
                <div className="outer">
                    <div className="card">
                        <div className="info">
                            <h3 className="title">6/10/2023</h3>
                            <p>Mở form đăng ký và bài dự thi</p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="info">
                            <h3 className="title">27/10/2023</h3>
                            <p> Đóng form đăng ký</p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="info">
                            <h3 className="title">31/11/2023</h3>
                            <p>Công bố TOP 30 lọt vào bán kết</p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="info">
                            <h3 className="title">12/11/2023</h3>
                            <p>Video shooting - Thi trực tiếp, mỗi thí sinh thể hiện bài diễn đạt chuẩn bị từ trước theo chủ đề được Ban Tổ Chức công bố.</p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="info">
                            <h3 className="title">20/11/2023</h3>
                            <p> Bắt đầu cuộc bình chọn TOP 10</p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="info">
                            <h3 className="title">02/12/2023</h3>
                            <p>Kết thúc cuộc bình chọn TOP 10</p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="info">
                            <h3 className="title">04/12/2023</h3>
                            <p>Công bố các thí sinh vào lọt vào Vòng Chung Kết </p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="info">
                            <h3 className="title">10/12/2023</h3>
                            <p>Vòng Chung Kết, vòng thi trực tiếp, thí sinh diễn thuyết với các chủ đề, từ khoá bất ngờ do Ban Tổ Chức cung cấp.</p>
                        </div>
                    </div>
                    
                    <div className="card">

                    </div>
                </div>
            </div>
        </Col>
    </Row>
);

export default TimeLineTree;